const config = {
  gatsby: {
    pathPrefix: '/',
    siteUrl: 'https://hasura.io',
    gaTrackingId: null,
    trailingSlash: false,
  },
  header: {
    logo: 'https://www.safefood.blue/images/bR_Wmark_CMYK.white.png',
    logoLink: '',
    title: 'Safefood',
    githubUrl: '',
    helpUrl: '',
    tweetText: '',
    social: `<div>
              <p>Need more help? </p>
              <a href = "mailto: support@bluerover.ai">Email Us: support@bluerover.ai</a>
            </div>`,
    links: [{ text: '', link: '' }],
    search: {
      enabled: true,
      indexName: 'safefood_docs',
      algoliaAppId: process.env.GATSBY_ALGOLIA_APP_ID,
      algoliaSearchKey: process.env.GATSBY_ALGOLIA_SEARCH_KEY,
      algoliaAdminKey: process.env.ALGOLIA_ADMIN_KEY,
    },
  },
  sidebar: {
    forcedNavOrder: [
      '/general',
      '/entity',
      '/alertsettings',
      '/user', // add trailing slash if enabled above
      '/handheld',
      '/menu',
      '/station',
      '/cooldown',
      '/dataentry',
      '/audittrail',
      '/datadownload',
      '/incidents',
      '/permissions',
      '/faqs'
    ],
    collapsedNav: [
      '/codeblock', // add trailing slash if enabled above
    ],
    links: [{ text: 'Safefood Login', link: 'https://www.safefood.blue/login' }],
    frontline: false,
    ignoreIndex: true,
    title:
      `<div style="font-family: Roboto;">Safefood Documentation</div>`,
  },
  siteMetadata: {
    title: 'Safefood Documentation',
    description: 'Documentation for Safefood by Bluerover.',
    ogImage: null,
    docsLocation: '',
    favicon: 'https://drive.google.com/file/d/12cPo4VU4vGmzeXFpyxsgkpvIcDR_D5M9/view?usp=sharing',
  },
  pwa: {
    enabled: false, // disabling this will also remove the existing service worker.
    manifest: {
      name: 'Gatsby Gitbook Starter',
      short_name: 'GitbookStarter',
      start_url: '/',
      background_color: '#6b37bf',
      theme_color: '#6b37bf',
      display: 'standalone',
      crossOrigin: 'use-credentials',
      icons: [
        {
          src: 'src/pwa-512.png',
          sizes: `512x512`,
          type: `image/png`,
        },
      ],
    },
  },
};

module.exports = config;
